module.exports = __webpack_public_path__ + "static/media/valuechain.edadf729.svg";